// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__12tb1","title":"BackImages_title__3-q2u","images":"BackImages_images__3EY-6"};